import { useRequestContext } from '@coolblue-development/next-request-context/client';
import { formatCurrency } from '../core/currency/formatCurrency.js';
import { formatCustom } from '../core/date/formatCustom.js';
import { formatFullDate } from '../core/date/formatFullDate.js';
import { formatFullDateTime } from '../core/date/formatFullDateTime.js';
import { formatFullTextDay } from '../core/date/formatFullTextDay.js';
import { formatFullTextDayAndDate } from '../core/date/formatFullTextDayAndDate.js';
import { formatMediumDate } from '../core/date/formatMediumDate.js';
import { formatMonthAbbreviation } from '../core/date/formatMonthAbbreviation.js';
import { formatNumericDate } from '../core/date/formatNumericDate.js';
import { formatNumericDateTime } from '../core/date/formatNumericDateTime.js';
import { formatRelativeDate } from '../core/date/formatRelativeDate.js';
import { formatRelativeDay } from '../core/date/formatRelativeDay.js';
import { formatRelativeMediumDate } from '../core/date/formatRelativeMediumDate.js';
import { formatRelativeMediumDateTime } from '../core/date/formatRelativeMediumDateTime.js';
import { formatRelativeShortDate } from '../core/date/formatRelativeShortDate.js';
import { formatRelativeTimeOfDay } from '../core/date/formatRelativeTimeOfDay.js';
import { formatShortDate } from '../core/date/formatShortDate.js';
import { formatTime } from '../core/date/formatTime.js';
import { formatNumber } from '../core/number/formatNumber.js';
import { useTranslation } from '../i18n/useTranslation.js';
export function useFormatNumericDate(date) {
    const { language, subsidiary } = useRequestContext();
    return formatNumericDate({ date, language, subsidiary });
}
export function useFormatTime(date) {
    const { language, subsidiary } = useRequestContext();
    return formatTime({ date, language, subsidiary });
}
export function useFormatNumericDateTime(date) {
    const { language, subsidiary } = useRequestContext();
    return formatNumericDateTime({ date, language, subsidiary });
}
export function useFormatFullDate(date) {
    const { language, subsidiary } = useRequestContext();
    return formatFullDate({ date, language, subsidiary });
}
export function useFormatFullDateTime(date) {
    const { language, subsidiary } = useRequestContext();
    return formatFullDateTime({ date, language, subsidiary });
}
export function useFormatShortDate(date) {
    const { language, subsidiary } = useRequestContext();
    return formatShortDate({ date, language, subsidiary });
}
export function useFormatMediumDate(date) {
    const { language, subsidiary } = useRequestContext();
    return formatMediumDate({ date, language, subsidiary });
}
export function useFormatRelativeMediumDateTime(date) {
    const { t } = useTranslation('dateUtils');
    const { language, subsidiary } = useRequestContext();
    const content = {
        today: t('today'),
        tomorrow: t('tomorrow'),
    };
    return formatRelativeMediumDateTime({ date, language, subsidiary, content });
}
export function useFormatRelativeDate(date) {
    const { t } = useTranslation('dateUtils');
    const { language, subsidiary } = useRequestContext();
    const content = {
        today: t('today'),
        yesterday: t('yesterday'),
        tomorrow: t('tomorrow'),
        thisWeek: t('thisWeek'),
        nextWeek: t('nextWeek'),
        lastWeek: t('lastWeek'),
        thisMonth: t('thisMonth'),
        nextMonth: t('nextMonth'),
        thisYear: t('thisYear'),
        nextYear: t('nextYear'),
    };
    return formatRelativeDate({ date, language, subsidiary, content });
}
export function useFormatRelativeShortDate(date) {
    const { t } = useTranslation('dateUtils');
    const { language, subsidiary } = useRequestContext();
    const content = {
        today: t('today'),
        tomorrow: t('tomorrow'),
    };
    return formatRelativeShortDate({ date, language, subsidiary, content });
}
export function useFormatRelativeMediumDate(date) {
    const { t } = useTranslation('dateUtils');
    const { language, subsidiary } = useRequestContext();
    const content = {
        today: t('today'),
        tomorrow: t('tomorrow'),
    };
    return formatRelativeMediumDate({ date, language, subsidiary, content });
}
export function useFormatRelativeDay(date) {
    const { t } = useTranslation('dateUtils');
    const { language, subsidiary } = useRequestContext();
    const content = {
        today: t('today'),
        tomorrow: t('tomorrow'),
    };
    return formatRelativeDay({ date, language, subsidiary, content });
}
export function useFormatCustom(date, options) {
    const { language, subsidiary } = useRequestContext();
    return formatCustom({ date, language, subsidiary, options });
}
export function useFormatFullTextDay(date) {
    const { language, subsidiary } = useRequestContext();
    return formatFullTextDay({ date, language, subsidiary });
}
export function useFormatFullTextDayAndDate(date) {
    const { language, subsidiary } = useRequestContext();
    return formatFullTextDayAndDate({ date, language, subsidiary });
}
export function useFormatRelativeTimeOfDay(date) {
    const { t } = useTranslation('dateUtils');
    const { language, subsidiary } = useRequestContext();
    const content = {
        yesterday: t('yesterday'),
        justNow: t('justNow'),
        tonight: t('tonight'),
        thisMorning: t('thisMorning'),
        thisAfternoon: t('thisAfternoon'),
        thisEvening: t('thisEvening'),
        today: t('today'),
        tomorrow: t('tomorrow'),
    };
    return formatRelativeTimeOfDay({ date, language, subsidiary, content });
}
export function useFormatMonthAbbreviation(date) {
    const { language, subsidiary } = useRequestContext();
    return formatMonthAbbreviation({ date, language, subsidiary });
}
export function useFormatCurrency(amount, options) {
    const { language, subsidiary } = useRequestContext();
    return formatCurrency({ amount, language, subsidiary, options });
}
export function useFormatNumber(number, options) {
    const { language, subsidiary } = useRequestContext();
    return formatNumber({ number, language, subsidiary, options });
}
//# sourceMappingURL=index.js.map